import { render, staticRenderFns } from "./HousingFilter.vue?vue&type=template&id=e8ad10e2&scoped=true&"
import script from "./HousingFilter.vue?vue&type=script&lang=js&"
export * from "./HousingFilter.vue?vue&type=script&lang=js&"
import style0 from "./HousingFilter.vue?vue&type=style&index=0&id=e8ad10e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ad10e2",
  null
  
)

export default component.exports